export enum NoteMode {
  View = 'view',
  Edit = 'Edit'
}
